import {FontAwesomeIcon as Icon} from '@fortawesome/react-fontawesome'
import {Panel} from 'components/Panel'
import {FormType} from 'mixins/FormTypes'
import {Http} from 'mixins/http'
import React, {Fragment} from 'react'
import {Redirect} from 'react-router-dom'
import Form from '../../mixins/form'
import {Tab} from '@headlessui/react'
import {classNames} from '../../utils/class-names'
import Trans from '../../components/Trans'
import {connect} from 'react-redux'
import {GlobalState} from 'state'
import {AuctionSettings} from 'domain-models'

type AcceptAgbProps = {
  settings: AuctionSettings
  basename: string
}

type AcceptAgbState = {
  form: FormType
  redirect: boolean
}

class AcceptAgb extends React.Component<AcceptAgbProps, AcceptAgbState> {
  private form: FormType = new Form({})

  constructor(props: AcceptAgbProps) {
    super(props)
    this.state = {
      redirect: false,
      form: this.form
    }
  };

  accept = async () => {
    await Http.post('/accept-agb', {state: this, form: this.state.form})
    this.setState({redirect: true})
  }

  render() {
    const {redirect} = this.state
    const {settings, basename} = this.props
    const src = settings?.agbUrl
    const urls = settings?.agbUrls

    if (redirect) {
      return <Redirect to='/' />
    }

    return (
      <div className='border-t-4 border-blue-800 overflow-y-scroll scrolling-smooth md:scrollbar  w-full h-full'>
        <div className='flex flex-col p-2 w-full max-w-2xl lg:max-w-3xl mx-auto'>
          <Panel>
            <div className='flex flex-col px-4 py-2 overflow-y-scroll scrolling-smooth scrollbar'>
              <div className='flex flex-col items-center justify-center'>
                <img src={basename + '/images/undraw_terms.png'} alt='login' className='w-32 h-32' />
                <div className='flex flex-col sm:flex-row flex-wrap w-full'>
                  <div className='text-gray-600 font-semibold tracking-wide w-full text-center mt-4 text-lg'>
                    <Icon icon='vote-yea' />
                    <span> <Trans>AGB akzeptieren</Trans></span>
                  </div>
                  <div className='text-gray-600 font-semibold tracking-wide w-full text-center mt-2'>
                    <span><Trans>Um an Auktionen teilnehmen zu können, müssen Sie die AGB akzeptieren.</Trans></span>
                  </div>
                </div>
                {
                  src && !urls
                    ?
                    <div className='block w-full h-full'>
                      <iframe src={src} height='400' width='100%' />
                    </div>
                    : urls ?
                      <Tab.Group as='div' className='mt-2 w-full'>
                        <div className='border-b border-gray-200'>
                          <Tab.List className='-mb-px flex space-x-8 px-4'>
                            {urls.map((url, index) => <Tab key={'tab-index-' + index} className={({selected}) =>
                              classNames(
                                selected ? 'text-indigo-600 border-indigo-600' : 'text-gray-900 border-transparent',
                                'flex-1 whitespace-nowrap border-b-2 py-4 px-1 text-base font-medium focus:outline-none'
                              )
                            }><Trans>AGB</Trans> {index+1}</Tab>)}
                          </Tab.List>
                          <Tab.Panels as={Fragment}>
                            {urls.map((url, index) => <Tab.Panel className="space-y-12 px-4 py-6 block w-full h-full" key={'tab-content-' + index}>
                                <iframe src={url} height='400' width='100%' />
                              </Tab.Panel>
                            )}
                          </Tab.Panels>
                        </div>
                      </Tab.Group>
                      :
                      <div className='text-gray-600 font-semibold w-full text-center mt-2 text-sm'>
                        <span><Trans>Wenden Sie sich an Ihren Ansprechpartner beim Autohaus um den Vorgang abzuschließen. Wenn die AGB akzeptiert wurde werden Sie für die Auktionen freigeschaltet.</Trans></span>
                      </div>
                }
              </div>

              <div className='mt-12 text-gray-600 font-semibold tracking-wide flex flex-row justify-between'>
                <button onClick={() => window.open(basename + '/logout', '_self')} className='block rounded px-6 py-2 whitespace-no-wrap hover:bg-gray-200 focus:outline-none'>
                  <Icon className='text-gray-700' icon='sign-out-alt' />
                  <span className='text-gray-700 font-semibold px-1'><Trans>Logout</Trans></span>
                </button>

                {
                  (src || urls)
                    ?
                    <button onClick={this.accept} className='block rounded px-6 py-2 whitespace-no-wrap hover:bg-gray-200 focus:outline-none'>
                      <Icon className='text-green-600' icon={this.state.form.busy ? 'spinner' : 'check'} spin={this.state.form.busy} />
                      <span className='text-green-600 font-semibold px-1'> <Trans>Akzeptieren</Trans></span>
                    </button>
                    : null}
              </div>
            </div>
          </Panel>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: GlobalState) => ({
  settings: state.app.settings,
  basename: state.app.basename
})

export default connect(mapStateToProps)(AcceptAgb)
